export interface Employee {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  fullName?: string;
  status: EmployeerStatus;
  lastLoginAt?: Date | null;
}

export interface CreateEmployee {
  email: string;
  firstName: string;
  lastName: string;
}

export interface UpdateEmployee {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  status: EmployeerStatus;
}

export enum EmployeerStatus {
  Active = 1,
  Deactivated = 2,
  Locked = 3,
}
